<script setup>
import { computed, onBeforeMount, onBeforeUnmount, watch } from 'vue'
import { useProfileStore } from '@/stores/profile'
import { useEcusModuleStore } from '@/stores/ecus-module'
import { usePointsStore } from '@/stores/points'
import { useWsStore } from '@/stores/ws'
import { useWsSubsStore } from '@/stores/wsSubs'
import { useCarinfoStore } from '@/stores/car-info'
import checkArrayIncludes from '@/helpers/checkArrayIncludes'
import UTACarNavi from '@/components/car/UTACarNavi.vue'
import UTAError404 from '@/components/UTAError404.vue'

const profileStore = useProfileStore()
const wsStore = useWsStore()
const wsSubsStore = useWsSubsStore()
const pointsStore = usePointsStore()
const ecusModuleStore = useEcusModuleStore()
const carinfoStore = useCarinfoStore()

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const carinfo = computed(() => carinfoStore.carinfo)
const carinfoProcess = computed(() => carinfoStore.carinfoProcess)
const profile = computed(() => profileStore.profile)

wsSubsStore.subCars({ cars: [props.uuid] })
wsStore.wsCurrentCars = [props.uuid]
pointsStore.readLatestPoint({ uuid_car_array: props.uuid })

if(checkArrayIncludes(profile.value.attr?.array, ['SUPER_ADMIN', 'DIAGNOSTIC'])) {
    ecusModuleStore.readEcuModules({ uuid_car_array: props.uuid })
}

onBeforeMount(() => {
    carinfoStore.readCarinfo(props.uuid)
})

onBeforeUnmount(() => {
    wsSubsStore.unsubCars({ cars: [props.uuid] })
    pointsStore.resetCarState()
    carinfoStore.setCarinfo({})
})

watch(profile, profileData => {
    if(checkArrayIncludes(profileData.attr?.array, ['SUPER_ADMIN', 'DIAGNOSTIC'])) {
        ecusModuleStore.readEcuModules({ uuid_car_array: props.uuid })
    }
})
</script>

<template>
    <div v-if="carinfoProcess" class="d-flex justify-content-center align-items-center h-100">
        <div class="loader">
            <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
    <div v-else class="page page--car">
        <div v-if="carinfo.uuid" class="page__container page__container--2cols align-items-stretch">
            <div class="page__leftcol">
                <UTACarNavi :uuid="props.uuid ? props.uuid : ''" />
            </div>
            <div class="page__rightcol">
                <router-view></router-view>
            </div>
        </div>
        <UTAError404 v-else />
    </div>
</template>
